// Custom Loox Rating Display - Heroicons Mini Star + Formatted Text
// YESYOU TEMPLATE ONLY
(function() {
  if (window.__looxRatingCustom) return;
  window.__looxRatingCustom = true;

  // Only run for yesyou template
  if (!document.body.classList.contains('tcc-yesyou-template') || !document.body.classList.contains('codex-template')) {
    return;
  }

  // Star SVG (filled) - from snippet icon-star-filled
  const starIconFilled = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M8.21896 2.59506C8.50808 1.90059 9.49242 1.90052 9.78146 2.59506L11.4289 6.55698L15.7063 6.89975C16.456 6.96024 16.7601 7.89663 16.1887 8.38608L12.9299 11.1771L13.926 15.3499C14.1006 16.0819 13.3035 16.6611 12.6613 16.2689L9.00021 14.0326L5.3381 16.2689C4.69597 16.6607 3.89986 16.0818 4.07443 15.3499L5.07053 11.1771L1.81174 8.38608C1.24028 7.89656 1.54418 6.96002 2.29416 6.89975L6.5715 6.55698L8.21896 2.59506Z" fill="#FAD16F"/>
  </svg>`;

  // Star SVG (outline) - from snippet icon-star-outline
  const starIconOutline = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M8.21896 2.59506C8.50808 1.90059 9.49242 1.90052 9.78146 2.59506L11.4289 6.55698L15.7063 6.89975C16.456 6.96024 16.7601 7.89663 16.1887 8.38608L12.9299 11.1771L13.926 15.3499C14.1006 16.0819 13.3035 16.6611 12.6613 16.2689L9.00021 14.0326L5.3381 16.2689C4.69597 16.6607 3.89986 16.0818 4.07443 15.3499L5.07053 11.1771L1.81174 8.38608C1.24028 7.89656 1.54418 6.96002 2.29416 6.89975L6.5715 6.55698L8.21896 2.59506Z" fill="none" stroke="#FAD16F" stroke-width="1.5"/>
  </svg>`;

  function formatReviewCount(count) {
    if (count >= 1000) {
      const thousands = Math.floor(count / 1000);
      return thousands + ',000+';
    }
    return count.toString();
  }

  function createCustomRating(rating, count) {
    const ratingValue = parseFloat(rating).toFixed(1);
    const reviewCount = formatReviewCount(parseInt(count));

    // Create stars container
    const starsContainer = document.createElement('div');
    starsContainer.className = 'loox-custom-stars';
    starsContainer.style.cssText = 'display: flex; align-items: center; gap: 0.25rem; margin-right: 0.5rem;';

    // Create 5 stars
    for (let i = 0; i < 5; i++) {
      const starWrapper = document.createElement('span');
      starWrapper.style.cssText = 'display: inline-flex; width: 18px; height: 18px; position: relative;';

      // Fill logic: if rating is 4.8, fill 4 full stars and 0.8 of the 5th
      const fillAmount = Math.max(0, Math.min(1, parseFloat(rating) - i));

      if (fillAmount >= 1) {
        // Fully filled star - only show filled, no outline
        starWrapper.innerHTML = starIconFilled;
      } else if (fillAmount > 0) {
        // Partially filled star - show outline as base, then clip filled version on top
        starWrapper.innerHTML = starIconOutline;
        const filledStar = document.createElement('span');
        filledStar.innerHTML = starIconFilled;
        filledStar.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; clip-path: inset(0 ' + ((1 - fillAmount) * 100) + '% 0 0); overflow: hidden;';
        starWrapper.appendChild(filledStar);
      } else {
        // Empty star - only show outline, no filled version
        starWrapper.innerHTML = starIconOutline;
      }

      starsContainer.appendChild(starWrapper);
    }

    // Create text container
    const textContainer = document.createElement('span');
    textContainer.className = 'loox-custom-text';
    textContainer.style.cssText = 'display: inline-flex; align-items: center;   font-size: 14px; line-height: 100%;';

    // Rating part - "4.9/5" in bold black, then normal "("
    const ratingSpan = document.createElement('span');
    ratingSpan.style.color = '#151716';

    // "4.9/5" part (bold, black)
    const ratingBold = document.createElement('span');
    ratingBold.textContent = ratingValue + '/5';
    ratingBold.style.fontWeight = '600';
    ratingBold.style.color = '#151716';

    // Normal "("
    const ratingOpenParen = document.createTextNode(' (');

    ratingSpan.appendChild(ratingBold);
    ratingSpan.appendChild(ratingOpenParen);

    // Review count part - number in bold black, then normal "Verified Reviews)"
    const reviewSpan = document.createElement('span');

    // Number part (bold, black)
    const reviewNumber = document.createElement('span');
    reviewNumber.textContent = reviewCount;
    reviewNumber.style.fontWeight = '600';
    reviewNumber.style.color = '#151716';

    // Normal "Verified Reviews)" text with opacity
    const reviewRest = document.createElement('span');
    reviewRest.textContent = ' Verified Reviews)';
    reviewRest.style.color = 'rgba(21, 23, 22, 0.7)'; // #151716 with 70% opacity (B2 in hex = 178/255 ≈ 0.7)

    reviewSpan.appendChild(reviewNumber);
    reviewSpan.appendChild(reviewRest);

    textContainer.appendChild(ratingSpan);
    textContainer.appendChild(reviewSpan);

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'loox-custom-rating';
    wrapper.style.cssText = 'display: flex; align-items: center; margin: 0 0 0.75rem 0;';
    wrapper.appendChild(starsContainer);
    wrapper.appendChild(textContainer);

    return wrapper;
  }

  function replaceLooxRating() {
    // Find all Loox rating elements
    const looxRatings = document.querySelectorAll('[data-loox-rating], .loox-rating, [class*="loox-rating"]');

    looxRatings.forEach(function(looxEl) {
      // Skip if already replaced
      if (looxEl.dataset.yyCustomReplaced === 'true') return;

      // Get rating and count from data attributes
      const rating = looxEl.getAttribute('data-rating') || looxEl.dataset.rating || '0';
      const count = looxEl.getAttribute('data-raters') || looxEl.dataset.raters || looxEl.getAttribute('data-count') || looxEl.dataset.count || '0';

      if (rating && count && parseFloat(rating) > 0 && parseInt(count) > 0) {
        // Clear all existing content
        looxEl.innerHTML = '';

        // Create and insert custom rating
        const customRating = createCustomRating(rating, count);
        looxEl.appendChild(customRating);

        // Preserve data attributes but mark as replaced
        looxEl.dataset.yyCustomReplaced = 'true';
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceLooxRating);
  } else {
    replaceLooxRating();
  }

  // Run after delays to catch Loox async loading
  [500, 1000, 2000, 3000, 5000].forEach(delay => {
    setTimeout(replaceLooxRating, delay);
  });

  // Watch for Loox elements being added
  const observer = new MutationObserver(function() {
    replaceLooxRating();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

  // Listen for Loox events if available
  if (window.Loox) {
    document.addEventListener('loox:loaded', replaceLooxRating);
  }
})();

